import {
  characterVotesPercentageByEpisode,
  episodeEngagementAndEmotionVote,
  showViewership
} from '../../config/filters';

const metricDetailsConfig = {
  CHARACTER_VOTES_FILTERS: characterVotesPercentageByEpisode,
  SHOW_VIEWERSHIP_FILTERS: showViewership,
  SHOW_ENGAGEMENT_FILTERS: episodeEngagementAndEmotionVote,

  CHARACTER_VOTES_PAGE_ID: 'characterVotesPercentageByEpisode',
  EPISODE_ENGAGEMENT_PAGE_ID: 'episodeEngagementAndEmotionVote',
  SHOW_ENGAGEMENT_PAGE_ID: 'episodeEngagementAndEmotionVote',
  SHOW_VIEWERSHIP_PAGE_ID: 'showViewership'
};

export default metricDetailsConfig;
